if (!customElements.get('collection-pills-mto')) {
  customElements.define(
    'collection-pills-mto',
    class CollectionPillsMto extends HTMLElement {
      connectedCallback() {
        this.pills = Array.from(this.querySelectorAll('.collection-pills-mto__pill'));
        this.pills.forEach((pill) => pill.addEventListener('click', this.onPillClick.bind(this)));
      }

      onPillClick(event) {
        const pill = event.currentTarget;
        const handle = pill.dataset.collectionHandle;
        // only intercept when a featured collection for this collection exists on the page,
        // otherwise let the link open the collection page as usual
        const target = handle && document.querySelector(`.collection[data-collection-handle="${handle}"]`);
        if (!target) return;

        event.preventDefault();
        this.setActive(pill);

        const header = document.querySelector('.section-header');
        const isSticky = header && getComputedStyle(header).position === 'sticky';
        const offset = isSticky ? header.getBoundingClientRect().height : 0;
        const top = target.getBoundingClientRect().top + window.scrollY - offset;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top, behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      setActive(activePill) {
        this.pills.forEach((pill) => {
          const isActive = pill === activePill;
          pill.classList.toggle('collection-pills-mto__pill--active', isActive);
          if (isActive) {
            pill.setAttribute('aria-current', 'true');
          } else {
            pill.removeAttribute('aria-current');
          }
        });
        // keep the selected pill visible inside the mobile carousel without moving the page vertically
        const list = activePill.closest('.collection-pills-mto__list');
        if (list && list.scrollWidth > list.clientWidth) {
          list.scrollTo({
            left: activePill.offsetLeft - (list.clientWidth - activePill.offsetWidth) / 2,
            behavior: 'smooth',
          });
        }
      }
    }
  );
}
